import * as _ from 'gleam:prelude'
import * as csv from 'papaparse'

export function parse(input) {
  const results = csv.parse(input, { delimiter: ';' })
  if (results.errors.length === 0) return _.Result$Ok(results.data)
  console.warn(results.errors)
  return _.Result$Error()
}
